// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Coupon_invalidDataError__nm5hS"};